import { useContext } from 'react';
import { createContext } from 'react';

import { BreadcrumbProps } from '../@types/BreadcrumbProps';

export const BreadcrumbContext = createContext<BreadcrumbProps>({} as BreadcrumbProps);

BreadcrumbContext.displayName = 'Breadcrumb';

const BreadcrumbProvider = (props: BreadcrumbProps) => (
	<BreadcrumbContext.Provider value={props}>{props.children}</BreadcrumbContext.Provider>
);

export const useBreadcrumb = () => {
	const context = useContext(BreadcrumbContext);

	return context;
};

export default BreadcrumbProvider;
